import { Grid } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import Button from '../../Component/Button'
import { useSelector } from 'react-redux'
import DropDown from '../../Component/DropDown'

import { AiOutlineInfoCircle, AiOutlineSwap, AiOutlineCheckCircle } from 'react-icons/ai'
import { BsSearch, BsExclamationLg } from 'react-icons/bs'
import OutsideClickHandler from 'react-outside-click-handler'
import { callWeb3Approval, callWeb3Balance, callWeb3Decimals, callWeb3SetLimit, callWeb3Swap, getTransactionHistory, redirectToMetamask, sendTransDetails, switchNetwork, walletConnectHandler } from '../../Utility/helpers'
import Web3 from 'web3'
import { useDispatch } from 'react-redux'
import { API, dark_mode, set_admin, set_balance, set_decimal, set_from, set_limit } from '../../Utility/constants'
import toast from 'react-hot-toast'
import { formatUnits, parseUnits } from "@ethersproject/units";
import Swal from 'sweetalert2'
import classNames from 'classnames'
import backgroundImage from '../../Styles/Assets/backgorund_day.png'
import DataTable, { createTheme } from 'react-data-table-component'
import transactionHistory from './history.json'
import TextInput from '../../Component/TextInput'
import StatusDropdown from '../../Component/StatusDropdown.js/index.js'
import metamaskIcon from '../../Styles/Assets/metamask-icon.png'
import copy from 'copy-to-clipboard'
import ReactTooltip from 'react-tooltip'

const columns = [
    {
        name: 'Date',
        selector: row => {
            return (
                <div>
                    <p style={{ margin: 0, color: '#B2B2B2', fontSize: 14, fontWeight: '700' }}>{row.date}</p>
                    <p style={{ margin: 0, color: '#B2B2B2', fontSize: 14, fontWeight: '700' }}>{row.time}</p>

                </div>
            )
        },
        width: "150px"

    },
    {
        name: 'Receivable Address',
        selector: row => {
            return (<div >
                <p style={{ margin: 0 }}>
                    {`${row.recipient_address.slice(
                        0,
                        8
                    )}..${row.recipient_address.slice(-8)}`}
                </p>
            </div>)
        },
        width: "250px",
        color: '#fff'

    },
    {
        name: 'Amount',
        selector: row => row.amount,
        width: "160px"

    },
    {
        name: 'Pair',
        selector: row => row.pair_name,
        width: "160px"

    },

    {
        name: 'TXID',
        selector: row => {
            return (row.request_id ? <>
                <div
                    data-tip
                    data-for="copys"
                    className="cursor_pointer"
                    onClick={() => {
                        copy(row.request_id);
                    }}>
                    {row.request_id.slice(
                        0,
                        8
                    )}..{row.request_id.slice(-8)}
                </div>
                <ReactTooltip
                    isCapture={true}
                    globalEventOff="click"
                    event="click"
                    place="right"
                    id="copys"
                    type="info"
                    effect="solid"
                >
                    <span>Copied</span>
                </ReactTooltip>
            </> : '')
        },
        width: "160px"

    },
    {
        name: 'Status',
        selector: row => {
            return (
                <div style={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                    {row.desc === "Swap Pending" ? <><BsExclamationLg style={{ color: '#FFBE27', fontSize: 14 }} />
                        <p style={{ paddingLeft: 5, margin: 0, color: '#FFBE27', fontSize: 14, fontWeight: '500' }}>
                            {row.desc}</p></> :
                        <>
                            <AiOutlineCheckCircle style={{ color: '#26E439', fontSize: 16 }} />
                            <p style={{ paddingLeft: 5, margin: 0, color: '#26E439', fontSize: 14, fontWeight: '500' }}>
                                {row.desc}
                            </p>
                        </>
                    }

                </div>
            )
        },
        width: "180px"

    },

];

const TransactionHistory = (props) => {
    let dispatch = useDispatch()

    const [fromDropDown, setFromDropDown] = useState(false)
    const mode = useSelector(state => state.mode)
    const networkPairs = useSelector(state => state.networkPairs)
    const [rowData, setRowData] = useState([])
    const [title, setTitle] = useState([])
    const [transactionResponse, setTransactionResponse] = useState([])
    const networks = useSelector(state => state.networks)
    const [loading, setLoading] = useState(false)
    const acc = useSelector(state => state.acc)
    const [from, setFrom] = useState(Object.keys(networkPairs)[0])
    const [search, setSearch] = useState("")






    const categoryHolder = classNames({
        category_holder: true,
        dark: mode === dark_mode ? true : false
    })

    const loadingState = classNames({
        loading_state: true,
        dark: mode === dark_mode ? true : false
    })

    useEffect(() => {
        window.ethereum && window.ethereum.on('chainChanged', (chainId) => {
            if (localStorage.getItem("from")) {
                if (networks[localStorage.getItem("from")].chainID === chainId && acc) {
                    checkApprovalLimit(localStorage.getItem("from"))
                }
            } else {
                if (networks[from].chainID === chainId && acc) {
                    checkApprovalLimit(from)
                }
            }

        });
        if (localStorage.getItem("from")) {
            if (acc && networks[localStorage.getItem("from")].chainID === window.ethereum.chainId) {
                checkApprovalLimit(localStorage.getItem("from"))
            }
        } else {
            if (acc && networks[from].chainID === window.ethereum.chainId) {
                checkApprovalLimit(from)
            }
        }

    }, [acc])
    useEffect(() => {
        if (from in networks) {
            window.web3 = new Web3(window.ethereum)
        }
    }, [from])
    const checkApprovalLimit = async (from) => {
        try {
            if (acc) {
                dispatch({ type: set_balance, payLoad: "" })
                let limit = await callWeb3Approval(networks[from].base_contract, acc, networks[from].cross_chain_contract, from)
                let balance = await callWeb3Balance(acc, from, networks[from].base_contract)
                let dec = await callWeb3Decimals(from, networks[from].base_contract)
                balance = formatUnits(balance, dec)
                limit = formatUnits(limit, dec)
                dispatch({ type: set_balance, payLoad: balance })
                dispatch({ type: set_limit, payLoad: limit })
                dispatch({ type: set_decimal, payLoad: Number(dec) })
                setLoading(false)
            }
        } catch (error) {
            toast.error(error.message)
            setLoading(false)
        }
    }

    createTheme('solarized', {
        text: {
            primary: mode === dark_mode ? '#f0f0f3' : '#231F20',
            secondary: '#2aa198',
        },
        background: {
            default: mode === dark_mode ? '#EE31AF' : '#f0f0f3',
        },
        context: {
            background: '#cb4b16',
            text: mode === dark_mode ? '#f0f0f3' : '#231F20',
        },
        divider: {
            default: '#073642',
        },
        action: {
            button: 'rgba(0,0,0,.54)',
            hover: 'rgba(0,0,0,.08)',
            disabled: 'rgba(0,0,0,.12)',
        },
    }, mode);
    let userAcc = useSelector(state => {
        return state.acc
    })


    const customStyles = {
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                color: mode === dark_mode ? '#f0f0f3' : '#231F20',
                backgroundColor: "transparent",
            },
        },
        cells: {
            style: {
                paddingLeft: '8px', // override the cell padding for data cells
                paddingRight: '8px',
                color: mode === dark_mode ? '#f0f0f3' : '#231F20',
                backgroundColor: "transparent"
            },
        },
    };

    useEffect(() => {
        if (userAcc) {
            getHistory()
        }
    }, [userAcc, search])

    const getHistory = async () => {
        let tableHeader = []
        setLoading(true)
        await getTransactionHistory({ recipient_address: userAcc }).then(res => {
            Object.keys(res.data.data).map((val) => {
                tableHeader.push(val)

                setTransactionResponse(res.data.data)
            })
            setTitle(tableHeader)
            setLoading(false)
        }).catch((e) => setLoading(false))
    }

    const clickHandler = async () => {
        let acc = await walletConnectHandler()
        dispatch({ type: set_admin, payLoad: acc })
    }

    const onSearch = (val) => {
        // console.log(val)
        setSearch(val)
    }

    return (
        <div className='swap_body'>
            <div className='swap_bg' style={{
                // backgroundImage: window.innerWidth < 768 ? "" : `url(${backgroundImage})`,
                height: "500px",
                width: '100%',
                position: 'absolute',
                bottom: 0,
                opacity: 0.05,
            }}>
            </div>
            <div className='status_body'>
                <div className='request'>
                    <div className='request_title' style={{ width: '100%' }}>
                        <h3>History</h3>
                    </div>
                </div>
                {title.length > 0 ? title.map(res =>
                    <div className={categoryHolder}>
                        <div className='category_head'>
                            <img src={networks[res].logo_url} alt={"img"} height={24} />
                            <p>{res}</p>
                        </div>
                        {/* {console.log(transactionResponse[res], "transactionResponse[res]")} */}
                        <DataTable
                            persistTableHead={true}
                            columns={columns}
                            data={transactionResponse[res]}
                            customStyles={customStyles}
                            pagination={transactionResponse[res] && transactionResponse[res].length < 10 ? false : true}
                        />
                    </div>
                ) : <div className={loadingState}>
                    <div className='loading_title'>
                        <p>No History Found.</p>
                        {userAcc ? "" : <p>Please Connect Your Metamask Wallet</p>}

                        {userAcc ? "" :
                            <Button
                                className={`button`}
                                action={() => { clickHandler() }}
                                loading={loading}

                                disabled={loading ? true : false}
                                style={{
                                    padding: window.innerWidth < 768 ? '5px 0px' : '10px 0px',
                                    fontSize: 18,
                                    fontWeight: 700,
                                    backgroundColor: mode === dark_mode ? '#fff' : '#EE31AF',
                                    color: mode === dark_mode ? '#EE31AF' : '#fff',
                                    width: window.innerWidth < 768 ? '70%' : '20%'
                                }}
                                type="fill"
                                title={loading ? "Fetching" : "Connect"}>
                            </Button>}

                        {/* </div> */}
                    </div>

                </div>}

            </div>
        </div >
    )

}
export default TransactionHistory;
